package org.gstechnovos.jexonplastech.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.coroutines.launch
import org.gstechnovos.jexonplastech.components.AchievementCard
import org.gstechnovos.jexonplastech.models.Achievement
import org.gstechnovos.jexonplastech.models.Section
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.util.AnimatePercentage
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.gstechnovos.jexonplastech.util.Constants.SECTION_WIDTH
import org.gstechnovos.jexonplastech.util.ObserveViewportEntered
import org.jetbrains.compose.web.css.px

@Composable
fun AchievementsSection() {
    Box(
        modifier = Modifier.id(Section.Achievements.id)
            .fillMaxWidth()
            .maxWidth(SECTION_WIDTH.px)
            .padding(topBottom = 100.px)
            .backgroundColor(Theme.LighterGray.rgb),
        contentAlignment = Alignment.Center
    ) {
        AchievementsContent()
    }
}

@Composable
fun AchievementsContent() {
    val breakPoint = LocalBreakpoint.current

    val scope = rememberCoroutineScope()
    var viewPortEntered by remember { mutableStateOf(false) }
    val animatedNumbers = remember { mutableStateListOf(0,0,0,0) }

    ObserveViewportEntered(sectionId = Section.Achievements.id, distanceFromTop = 700.0, onViewportEntered = {
        viewPortEntered = true
        Achievement.entries.forEach { achievement ->
            scope.launch {
                AnimatePercentage(
                    percentage = achievement.number,
                    delay = 25L,
                    onUpdate = { animatedNumbers[achievement.ordinal] = it }
                )
            }
        }
    })

    SimpleGrid(numColumns = numColumns(base = 1, md = 2, lg = 4)){
        Achievement.entries.forEach { achievement -> AchievementCard(
            modifier = Modifier.margin(
                right = if (achievement == Achievement.Team) 0.px else {
                    if (breakPoint > Breakpoint.SM) 40.px else 0.px
                },
                bottom = if (breakPoint > Breakpoint.MD) 0.px else 40.px
            ),
            animatedNumber = if (viewPortEntered) animatedNumbers[achievement.ordinal] else 0,
            achievement = achievement) }
    }
}